import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PartnersIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_595_3558)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.4375 16.875C6.34892 16.875 4.34588 16.0454 2.86904 14.5685C1.39219 13.0916 0.5625 11.0886 0.5625 9C0.5625 6.91142 1.39219 4.90838 2.86904 3.43153C4.34588 1.95469 6.34892 1.125 8.4375 1.125",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.4375 1.125C8.4375 1.125 4.5 3.375 4.5 9C4.5 14.625 8.4375 16.875 8.4375 16.875",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.43707 5.625H1.32031",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.43707 12.375H1.32031",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.8125 3.375C11.8125 3.97174 12.0496 4.54403 12.4715 4.96599C12.8935 5.38795 13.4658 5.625 14.0625 5.625C14.6592 5.625 15.2315 5.38795 15.6535 4.96599C16.0754 4.54403 16.3125 3.97174 16.3125 3.375C16.3125 2.77826 16.0754 2.20597 15.6535 1.78401C15.2315 1.36205 14.6592 1.125 14.0625 1.125C13.4658 1.125 12.8935 1.36205 12.4715 1.78401C12.0496 2.20597 11.8125 2.77826 11.8125 3.375Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M16.02 7.38452L14.0625 10.125L12.105 7.38452C11.6672 7.69516 11.3102 8.10594 11.0636 8.58271C10.817 9.05941 10.688 9.58824 10.6875 10.125V12.375C10.6875 12.6734 10.806 12.9596 11.017 13.1705C11.2279 13.3815 11.5142 13.5 11.8125 13.5H12.375V15.75C12.375 16.0484 12.4935 16.3346 12.7045 16.5455C12.9155 16.7565 13.2017 16.875 13.5 16.875H14.625C14.9233 16.875 15.2095 16.7565 15.4205 16.5455C15.6315 16.3346 15.75 16.0484 15.75 15.75V13.5H16.3125C16.6108 13.5 16.897 13.3815 17.108 13.1705C17.319 12.9596 17.4375 12.6734 17.4375 12.375V10.125C17.437 9.58824 17.308 9.05941 17.0614 8.58271C16.8149 8.10594 16.4578 7.69516 16.02 7.38452Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.24528",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_595_3558",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
